import { getReceivedConnections } from '@/api/friends-api';
import { useQuery } from '@tanstack/react-query';

// The concerns endpoint covers at most 50 circle members, so fetching the
// watched-over list at the same size keeps the two in step for alert filtering.
const WATCHING_OVER_PAGE_SIZE = 50;

/**
 * The people the current user watches over: accepted connections the other
 * person started. Shared by the dashboard's "People You're Watching Over"
 * section and the circle-alerts filter so both read one cached query.
 */
export function useWatchingOver({
  enabled = true
}: {
  enabled?: boolean;
} = {}) {
  return useQuery({
    queryKey: ['receivedConnections', { size: WATCHING_OVER_PAGE_SIZE }],
    queryFn: () => getReceivedConnections({ size: WATCHING_OVER_PAGE_SIZE }),
    enabled
  });
}
